import React from 'react';
import './RadioCheckInput.sass'

RadioCheckInput.propTypes = {};

function RadioCheckInput(props) {
    return (
        <div className={'RadioCheckInput'}>
            <input key={props.keys}
                   onChange={e => props.onChange(e)}
                   name={props.name}
                   value={props.value}
                   type="radio"
                   defaultValue={props.defaultValue}
                   id={props.value + props.title + props.name}
                   checked={props.checked}
                   className={'checkbox'}
            />
            <label
                htmlFor={props.value + props.title + props.name}>{props.title}</label>
        </div>
    );
}

export default RadioCheckInput;
